import type { AdminViewDefinition } from "../components/admin-components.js";
import { auditAdminViews } from "./audit/audit-pages.js";
import { authAdminViews } from "./auth/auth-pages.js";
import { domainAdminViews } from "./domains/domain-pages.js";
import { installationAdminViews } from "./installations/installation-pages.js";
import { jobAdminViews } from "./jobs/job-pages.js";
import { operationAdminViews } from "./operations/operation-pages.js";
import { usageAdminViews } from "./usage/usage-pages.js";

export const primaryAdminViews: AdminViewDefinition[] = [
  {
    id: "support-feedback",
    navId: "support-feedback",
    title: "Support & Feedback",
    description: "Review merchant questions, feedback, and support conversations.",
  },
  ...authAdminViews,
  ...operationAdminViews,
  ...installationAdminViews,
  ...domainAdminViews,
  ...jobAdminViews,
  ...usageAdminViews,
  ...auditAdminViews,
];
